
import {doubleFigure} from "@/shared/helpers/dates";
import {orderNumberDay} from "@/console-new/helpers/orders";
import {useCurrencyStore} from "@/shared/stores";
import {getNative, isNative} from "@/shared/helpers/webapp";
import {useNativeStore} from "@/console-new/stores";
import {useSunmiStore} from "@/console-sun/stores/sunmi.store";
import EscPos from "@/shared/helpers/EscPos";

// Printing of new orders' summaries
export default class EscPosOrders extends EscPos {

	static init() {
		if (!!EscPosOrders.instance) {
			return EscPosOrders.instance;
		}
		EscPosOrders.instance = new EscPosOrders();
		return EscPosOrders.instance;
	}

	handleOrdersPrint(orders) {
		if(!useSunmiStore().canLocalPrint) {
			return;
		}
		const nativeStore = useNativeStore();
		let alreadyPrinted = localStorage.getItem("AndroidAlreadyPrinted");
		if(alreadyPrinted !== null) {
			alreadyPrinted = JSON.parse(alreadyPrinted);
		} else {
			alreadyPrinted = [];
		}

		let excludedStations = nativeStore.excludedStations.map(s => s !== "null" ? parseInt(s) : s);

		let printProductsSeparately = nativeStore.isPrintProductsSeparately;

		let printed = false;
		for(let i = 0; i < orders.length; i++) {
			let stationId = orders[i].payment_user_id || orders[i].staff_user_id;
			if(excludedStations.includes(stationId ? Number(stationId) : "null")) {
				continue;
			}
			if(!alreadyPrinted.includes(orders[i].order_id)) {
				if(printProductsSeparately) {
					let order = orders[i];
					for(let j = 0; j < order.items.length; j++) {
						let item = order.items[j];
						for(let q = 0; q < item.quantity; q++) {
							let singleItem = Object.assign({}, item, {quantity: 1});
							let singleItemOrder = Object.assign({}, order, {items: [singleItem]});
							let resultToPrint = this.getOrdersRawData([singleItemOrder], true);
							if(resultToPrint === null || resultToPrint === "") {
								continue;
							}
							useSunmiStore().enqueuePrint(resultToPrint);
						}
					}
				} else {
					let resultToPrint = this.getOrdersRawData([orders[i]], false);
					if(resultToPrint === null || resultToPrint === "") {
						continue;
					}
					useSunmiStore().enqueuePrint(resultToPrint);
				}
				alreadyPrinted.push(orders[i].order_id);
				printed = true;
			}
		}
		if(alreadyPrinted.length > 500) {
			alreadyPrinted = alreadyPrinted.slice(alreadyPrinted.length - 100);
		}
		localStorage.setItem("AndroidAlreadyPrinted", JSON.stringify(alreadyPrinted));

		if(printed && getNative().playNewOrder) {
			getNative().playNewOrder();
		}

	}

	getOrdersRawData(orders, exploded = false) {
		let result = "";
		let numOrders = orders.length;


		let excludedCategories = [];
		const nativeStore = useNativeStore();
		if(isNative()) {
			let androidExcludedCategories = nativeStore.excludedCategories;
			excludedCategories = androidExcludedCategories.map(category_id => Number(category_id));
		}
		if(excludedCategories.length > 0) {

			let newOrders = [];
			for(let i = 0; i < numOrders; i++) {
				let orderItems = orders[i].items.filter(item => !excludedCategories.includes(item.category_id));
				if(orderItems.length !== 0) {
					let orderFiltered = {...orders[i], items: orderItems};
					newOrders.push(orderFiltered);
				}
			}
			orders = newOrders;
			numOrders = orders.length;

			if(numOrders === 0) {
				return null;
			}

		}

		let totalItems = orders.reduce((acc, order) => acc + order.items.length, 0);
		if(totalItems === 0) {
			return null;
		}

		let printTotal = nativeStore.isPrintTotal;

		let total = printTotal ? this.ordersTotal(orders) : 0;
		let partialTotal = printTotal ? this.ordersTotalFromItems(orders) : 0;
		let additionalCosts = printTotal ? orders.reduce((acc, order) => acc + order.additionalCosts, 0) : 0;

		for(let i = 0; i < numOrders; i++) {

			let firstOfMany = null;
			if(numOrders > 1) {
				firstOfMany = i === 0;
			}
			result += this.printOrder(orders[i], firstOfMany, exploded);

			if (i === numOrders-1 && !exploded) {

				let status = this.getPrintableOrderStatus(orders[i]);
				result += this.justifyCenter(this.bold(this.doubleSize(status)));
				if(printTotal) {
					let hasSubtotal = excludedCategories.length > 0 && partialTotal < total;
					if(hasSubtotal) {
						result += "\n"+this.justifyCenter(this.bold("Subtot parziale " + this.formatPriceString(partialTotal)));
					}
					if(additionalCosts !== 0) {
						if(!hasSubtotal) {
							result += "\n";
						}
						result += this.justifyCenter(this.bold("Subtot " + this.formatPriceString(total)));
						result += this.justifyCenter(this.bold("Supplementi " + this.formatPriceString(additionalCosts)));
					}
					result += this.justifyCenter(this.bold(this.doubleSize("Tot " + this.formatPriceString(total + additionalCosts))))+"\n";
				}
			}

			result += "\n";

		}

		result += "\n\n\n";
		result += "\x1d\x56\x31"; // GS V 1 - partial cut

		return result;

	}

	printOrder(order, firstOfMany, exploded = false) {
		let result = "";

		const nativeStore = useNativeStore();
		let doubleSizeItems = nativeStore.isFontDoubleSize;
		let fixedSizeRight = nativeStore.isFixedSizeRight;

		let convertedDate = order.date;
		let timePart = doubleFigure(convertedDate.getHours()) + ":" + doubleFigure(convertedDate.getMinutes());
		if(exploded) {
			timePart += " " + doubleFigure(convertedDate.getDate()) + "/" + doubleFigure(convertedDate.getMonth() + 1);
		}
		result += this.spaceBetween(orderNumberDay(order), timePart, false, true);

		if(firstOfMany === true || firstOfMany === null) {
			let titles = this.getPrintableOrderTitle(order);
			if(titles.title instanceof Array) {
				for(let i = 0; i < titles.title.length; i++) {
					result += this.justifyCenter(this.bold(this.doubleSize(this.replaceUnprintableChars(titles.title[i]))));
				}
			} else {
				result += this.justifyCenter(this.bold(this.doubleSize(this.replaceUnprintableChars(titles.title))));
			}
			if(titles.subtitle) {
				if(titles.subtitle instanceof Array) {
					for(let i = 0; i < titles.subtitle.length; i++) {
						result += this.justifyCenter(this.bold(this.replaceUnprintableChars(titles.subtitle[i])));
					}
				} else {
					result += this.justifyCenter(this.bold(this.replaceUnprintableChars(titles.subtitle)));
				}
			}
		} else {
			result += this.justifyCenter(this.bold("Altro ordine"));
		}

		let separatorChar = exploded ? "*" : "-";
		result += this.separator(separatorChar);

		for(let i = 0; i < order.items.length; i++) {
			let item = order.items[i];
			result += "\n";
			if(fixedSizeRight && !exploded) {
				result += this.fixedRight(this.replaceUnprintableChars(item.name), "x"+item.quantity, doubleSizeItems, true);
			} else {
				result += this.spaceBetween(this.replaceUnprintableChars(item.name), "x"+item.quantity, doubleSizeItems, true);
			}

			for(let y = 0; y < item.products.length; y++) {
				let productName = item.products[y].product_name;
				let quantity = item.products[y].quantity;
				if(fixedSizeRight && !exploded) {
					result += this.fixedRight("  + "+this.replaceUnprintableChars(productName), "x"+quantity, doubleSizeItems, true);
				} else {
					result += this.spaceBetween("  + "+this.replaceUnprintableChars(productName), "x"+quantity, doubleSizeItems, true);
				}
			}

			if(item.note) {
				result += this.bold("Note prodotto: "+this.replaceUnprintableChars(item.note));
				result += "\n";
			}

			result += this.separator(separatorChar);
		}

		if(order.notes) {
			result += "\n";
			result += this.justifyCenter(this.bold("Note"))+"\n";
			result += this.justifyCenter(this.bold(this.replaceUnprintableChars(order.notes)));
		}

		result += exploded ? "\n" : "\n\n";
		return result;
	}

	getPrintableOrderTitle(order) {
		let title = "";
		let subtitle = null;

		if(order.order_mode === "qr") {
			subtitle = [];
			if(order.name !== null && order.table_number !== null) {
				subtitle.push("Area " + order.table_number);
				title = order.name;
			} else if(order.name !== null) {
				title = order.name;
			} else if(order.table_number !== null) {
				title = order.table_number;
			}
			if(typeof order.room !== "undefined" && order.room !== null && order.room.name !== null) {
				subtitle.push(order.room.name);
			}
		} else if(order.order_mode === "delivery") {
			subtitle = [];
			title = [];
			if(order.address !== null) {
				if(order.address.via !== null && order.address.civico !== null && order.address.comune !== null && order.address.zip !== null) {
					title.push(order.address.via + " " + order.address.civico);
					title.push(order.address.comune + ", " + order.address.zip);
				} else {
					title.push(order.address.address);
				}
				if(order.address.details !== null) {
					subtitle.push(order.address.details);
				}
			} else {
				title.push("Delivery");
			}
			if(order.user_name !== null) {
				subtitle.push("Nome: "+order.user_name);
			}
			if(order.user_phone !== null) {
				subtitle.push("Tel: "+order.user_phone);
			}
			if(order.delivery_scheduled_date) {
				let orderDate = order.delivery_scheduled_date;
				title.push("Cons "+(orderDate.getHours() < 10 ? "0"+orderDate.getHours() : orderDate.getHours())+":"+(orderDate.getMinutes() < 10 ? "0"+orderDate.getMinutes() : orderDate.getMinutes()) +
					" "+orderDate.getDate()+"/"+(orderDate.getMonth()+1));
			}
		} else if(order.order_mode === "takeaway") {
			title = [];
			if(order.user_name !== null) {
				title.push(order.user_name);
			} else {
				title.push("Asporto");
			}
			if(order.takeaway_date) {
				let orderDate = order.takeaway_date;
				title.push("Rit "+(orderDate.getHours() < 10 ? "0"+orderDate.getHours() : orderDate.getHours())+":"+(orderDate.getMinutes() < 10 ? "0"+orderDate.getMinutes() : orderDate.getMinutes()) +
					" "+orderDate.getDate()+"/"+(orderDate.getMonth()+1));
			}

			if(order.user_phone !== null) {
				subtitle = "Tel: " + order.user_phone;
			}
		} else if(order.order_mode === "counter") {
			title = "Vendita diretta";
		}

		return {title: title, subtitle: subtitle};
	}

	ordersTotal(orders) {
		let result = 0;
		orders.forEach((order) => {
			result += Number(order.total);
		});
		return result;
	}

	ordersTotalFromItems(orders) {
		let result = 0;
		orders.forEach((order) => {
			order.items.forEach((item) => {
				result += Number(item.price) * Number(item.quantity);

				item.products.forEach((itemProduct) => {
					result += Number(itemProduct.price) * Number(itemProduct.quantity);
				});
			});
		});
		return result;
	}

	getPrintableOrderStatus(order) {
		let status = "Sconosciuto";
		if (order.paid) {
			status = "Pagato";
			if (order.type === "btc") {
				status = "Pagato Bitcoin";
			} else if (order.type === "satispay") {
				status = "Pagato Satispay";
			} else if (order.type === "klarna") {
				status = "Pagato Klarna";
			} else if (order.type === "paylater") {
				status = "Non riscosso";
			}
		} else {
			status = "** Non pagato **";
		}
		return status.toUpperCase();
	}

	formatPriceString(price) {
		return useCurrencyStore().dbToActualValue(price).toFixed(2).replace(".",",") + " " + useCurrencyStore().currCurrency.code;
	}
}
